import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-officers',
  templateUrl: './officers.component.html',
  styleUrls: ['./officers.component.scss']
})
export class OfficersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
